import {createReducer} from '@reduxjs/toolkit';
import keyBy from 'lodash/keyBy';
import pickBy from 'lodash/pickBy';

import {
  fetchItemTypes,
  resetSelectedItemTypes,
  selectItemTypes,
} from '../actions/item-types.js';
import {loadSearch, searchSingleItem} from '../actions/search.js';
import {GOOD_ITEM_TYPES} from '@explorer/constants/item-types';

export const initialState = {
  types: [],
  selected: pickBy(GOOD_ITEM_TYPES, Boolean),
  typesMap: null,
};

const itemTypes = createReducer(initialState, builder => {
  builder.addCase(fetchItemTypes.fulfilled, (state, {payload: itemTypes}) => {
    state.types = itemTypes.map(type => type.id);
    state.selected =
      Object.keys(state.selected).length === 0
        ? initialState.selected
        : state.selected;
    state.typesMap = keyBy(itemTypes, 'id');
  });

  builder.addCase(selectItemTypes, (state, {payload: itemTypes}) => {
    state.selected = itemTypes.reduce((types, id) => {
      return {
        ...types,
        [id]: true,
      };
    }, {});
  });

  builder.addCase(resetSelectedItemTypes, state => {
    state.selected = initialState.selected;
  });

  builder.addCase(loadSearch, (state, {payload: search}) => {
    state.selected = search.item_types.reduce((types, id) => {
      return {
        ...types,
        [id]: true,
      };
    }, {});
  });

  builder.addCase(searchSingleItem, (state, {payload: item}) => {
    state.selected = {[item.properties.item_type]: true};
  });
});

export default itemTypes;
